.gradient_placeholder {

    &[data-gradient="0"] {
        background: linear-gradient(180deg, #b86bf8 0%, #6bb5f8 100%);
    }

    &[data-gradient="1"] {
        background: linear-gradient(180deg, #f86bdf 0%, #6b6bf8 100%);
    }

    &[data-gradient="2"] {
        background: linear-gradient(180deg, #f87a7a 0%, #b47af8 100%);
    }

    &[data-gradient="3"] {
        background: linear-gradient(180deg, #fc8e51 0%, #fa61f9 100%);
    }

    &[data-gradient="4"] {
        background: linear-gradient(180deg, #fccf58 0%, #fa7e69 100%);
    }

    &[data-gradient="5"] {
        background: linear-gradient(180deg, #cafc58 0%, #fac669 100%);
    }

    &[data-gradient="6"] {
        background: linear-gradient(180deg, #6bfc56 0%, #fadd66 100%);
    }

    &[data-gradient="7"] {
        background: linear-gradient(180deg, #72fcc3 0%, #e4fa82 100%);
    }

    &[data-gradient="8"] {
        background: linear-gradient(180deg, #79d9fc 0%, #89fa8e 100%);
    }

    &[data-gradient="9"] {
        background: linear-gradient(180deg, #7784fc 0%, #87fad9 100%);
    }

    &[data-gradient="10"] {
        background: linear-gradient(180deg, #866afc 0%, #7af8fa 100%);
    }
}
